var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GetStartedInfo',{attrs:{"cardImagePath":"img/growth/groups-collapsable-section_minified.svg","footerIconSrc":_vm.footerIconSrc,"footerText":_vm.footerText,"header":"Save time with group-based bulk actions","listItems":_vm.listItems},on:{"actionClicked":_vm.showModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }